module.exports = __webpack_public_path__ + "media/images/emblems/Vezia-coat_of_arms-bbc0f414ea71d102648f512372c27735.svg";